/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import HelpCenterSettingsEmbeddedWidgetsAppQuery, {
	type HelpCenterSettingsEmbeddedWidgetsAppQuery as HelpCenterSettingsEmbeddedWidgetsAppQueryType,
} from './__generated__/HelpCenterSettingsEmbeddedWidgetsAppQuery.graphql.ts';
import HelpCenterSettingsEmbeddedWidgetsAppNewQuery, {
	type HelpCenterSettingsEmbeddedWidgetsAppNewQuery as HelpCenterSettingsEmbeddedWidgetsAppNewQueryType,
} from './__generated__/HelpCenterSettingsEmbeddedWidgetsAppNewQuery.graphql.ts';

type EmbeddedWidgetsEntryPointComponent = EntryPointComponent<
	{
		embeddedWidgetsQuery: HelpCenterSettingsEmbeddedWidgetsAppQueryType;
		embeddedWidgetsNewQuery: HelpCenterSettingsEmbeddedWidgetsAppNewQueryType;
	},
	{},
	{},
	{} | null
>;

export const embeddedWidgetsEntryPoint: EntryPoint<
	EmbeddedWidgetsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<EmbeddedWidgetsEntryPointComponent>(
		/* webpackChunkName: "async-help-center-setting-embedded-widgets-app" */ './HelpCenterSettingsEmbeddedWidgetsApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId, widgetId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => ({
		queries: {
			embeddedWidgetsQuery: {
				parameters: HelpCenterSettingsEmbeddedWidgetsAppQuery,
				variables: {
					cloudId,
					helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
					widgetId: widgetId ?? '',
					skip: fg('csm-omni-channel-live-chat-in-widget'),
				},
				options: { fetchPolicy: 'store-or-network' as const },
			},
			embeddedWidgetsNewQuery: {
				parameters: HelpCenterSettingsEmbeddedWidgetsAppNewQuery,
				variables: {
					helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
					skip: !fg('csm-omni-channel-live-chat-in-widget'),
				},
				options: { fetchPolicy: 'store-or-network' as const },
			},
		},
	}),
});
